import { Routes, Route, useLocation, Outlet, useNavigate } from 'react-router-dom';
import { RoutesType } from 'shared/types/routes/routers-type';
import Authorization from 'pages/auth/Authorization';
import { InsuranceContractPage } from 'pages/insurance-contract-page/InsuranceContractPage';
import { InsuranceContracts } from 'pages/insurance-contracts/InsuranceContracts';
import { Box } from '@mui/material';
import appStyles from 'app/providers/theme/App.module.css';
import DevPage from 'pages/dev-page/DevPage';
import InsurancePrograms from 'pages/insurance-programs/InsurancePrograms';
import { ProgramCase } from 'pages/program-case/ProgramCase';
import InsuredPersons from 'pages/insured-persons/InsuredPersons';
import InsuredPersonCase from 'pages/insured-person-case/InsuredPersonCase';
import Tasks from 'pages/tasks/Tasks';
import Task from 'pages/task/Task';
import CreateTask from 'pages/create-task/CreateTask';
import { useEffect, useState } from 'react';
import { Header } from 'shared/app-drawer/Header';
import { AppDrawer } from 'shared/app-drawer/AppDrawer';
import ProcessingPolicy from 'features/processing-policy/ui/ProcessingPolicy';
import Contacts from 'pages/contacts/Contacts';
import Feedback from 'pages/feedback/Feedback';
import { ProtectedRoute } from './ProtectedRoute';
import { ValidatedRoute } from './ValidatedRoute';
import NotFoundPage from 'pages/page-404/Page404';
import Statistics from 'pages/statistics/Statistics';
import EditTask from 'pages/edit-task/EditTask';
import { fetchAppDrawer } from 'entities/app-drawer/actions/fetch-app-drawer';
import { useAppDispatch } from 'shared/utils/hooks/useRedux';
import Projects from 'pages/projects/Projects';
import LoaderVerify from 'shared/loader-verify/LoaderVerify';
import BonusProgram from 'pages/bonus-program/BonusProgram';
import ModalNew from 'shared/modal-new/ModalNew';
import { AppPage } from 'pages/app-page/AppPage';
import { AppSpot } from 'pages/app-page/AppSpot';

const useBodyBackground = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === RoutesType.Auth) {
      document.body.style.backgroundColor = '#0054E6';
      document.body.style.overflow = 'hidden';
    } else if (location.pathname === RoutesType.Policy || location.pathname === RoutesType.AppPage) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.backgroundColor = 'white';
    }
  }, [location]);
};

const AppLayout: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname === "/") {
      navigate(RoutesType.ContractsList);
    }
  }, [location.pathname]);

  const clearStorage = () => {
    localStorage.removeItem('persist:root');
  };

  useEffect(() => {
    clearStorage()
  }, [])

  return (
    <>
      <Header />
      <Box className={appStyles.appContainer}>
        <AppDrawer />
        <Box className={appStyles.content}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

const AppRouter: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [isAppDrawerLoaded, setIsAppDrawerLoaded] = useState(false);
  const [isAuthRoute, setIsAuthRoute] = useState(false);

  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const isModalShownBefore = localStorage.getItem('isShowModal');
    if (isModalShownBefore === null) {
      localStorage.setItem('isShowModal', JSON.stringify(false));
    }
  }, []);
  useEffect(() => {
    const isModalShownBefore = JSON.parse(
      localStorage.getItem('isShowModal') || 'false'
    );
    if (location.pathname === RoutesType.ContractsList && !isModalShownBefore) {
      setShowModal(true);
    }
  }, [location.pathname]);
  const handleCloseModal = () => {
    localStorage.setItem('isShowModal', JSON.stringify(true));
    setShowModal(false);
  };
  // useEffect(() => {
  //   const loadAppDrawer = async () => {
  //     if (location.pathname !== RoutesType.Auth) {
  //       await dispatch(fetchAppDrawer()).unwrap();
  //       setIsAppDrawerLoaded(true);
  //     }


  //   };
  //   loadAppDrawer();
  // }, [dispatch]);

  // useBodyBackground();

  // if (!isAppDrawerLoaded) {
  //   return <LoaderVerify title="Загрузка прав доступа..." />;
  // }
  //  useEffect(() => {
  //   const loadAppDrawer = async () => {
  //     if (!isAuthRoute) {
  //       try {
  //         await dispatch(fetchAppDrawer()).unwrap();
  //       } catch (e) {
  //         // Если ошибка (например, нет сессии), не устанавливаем isAppDrawerLoaded в true
  //         // и не показываем LoaderVerify на маршруте авторизации
  //         if (!isAuthRoute) {
  //           setIsAppDrawerLoaded(true); // Чтобы не висел вечно на неавторизованных маршрутах
  //         }
  //       } finally {
  //         if (!isAuthRoute) {
  //           setIsAppDrawerLoaded(true);
  //         }
  //       }
  //     }
  //   };
  //   loadAppDrawer();
  // }, [dispatch, isAuthRoute]);
  useEffect(() => {
    const loadAppDrawer = async () => {
      // Не грузим AppDrawer на маршруте авторизации
      if (location.pathname === RoutesType.Auth) {
        setIsAppDrawerLoaded(true); // Чтобы не показывать лоадер
        return;
      }

      try {
        await dispatch(fetchAppDrawer()).unwrap();
      } catch (e) {
        // console.log(e);

        // Если ошибка (например, нет сессии), перенаправляем на авторизацию
        // или просто убираем лоадер, если не хотите редирект
        // navigate(RoutesType.Auth);
      } finally {
        setIsAppDrawerLoaded(true);
      }
    };

    loadAppDrawer();
  }, [dispatch, location.pathname, isAuthRoute]);

  useBodyBackground();

  // Не показываем LoaderVerify на маршруте авторизации
  if (!isAuthRoute && !isAppDrawerLoaded) {
    return <LoaderVerify title="Загрузка прав доступа..." />;
  }


  return (
    <>
      {showModal && (
        <ModalNew handleCloseModal={handleCloseModal}/>
      )}
      <Routes>
        <Route path={RoutesType.Auth} element={<Authorization />} />
        <Route path={RoutesType.Policy} element={<ProcessingPolicy />} />
        <Route path={RoutesType.AppPage} element={<AppPage />} /> 
        <Route path={RoutesType.AppSpot} element={<AppSpot />} />
        
        <Route element={<AppLayout />}>
          <Route path={RoutesType.ContractsList} element={<ProtectedRoute key={location.pathname} component={<InsuranceContracts />} />} />
          <Route path={RoutesType.ContractsCase} element={<ProtectedRoute key={location.pathname} component={<ValidatedRoute component={<InsuranceContractPage />} />} />} />
          <Route path={RoutesType.ProgramsList} element={<ProtectedRoute key={location.pathname} component={<InsurancePrograms />} />} />
          <Route path={RoutesType.ProgramsCase} element={<ProtectedRoute key={location.pathname} component={<ValidatedRoute component={<ProgramCase />} />} />} />
          <Route path={RoutesType.InsuredPersons} element={<ProtectedRoute key={location.pathname} component={<InsuredPersons />} />} />
          <Route path={RoutesType.Dev} element={<ProtectedRoute key={location.pathname} component={<DevPage />} />} />
          <Route path={RoutesType.InsuredPersonCase} element={<ProtectedRoute key={location.pathname} component={<ValidatedRoute component={<InsuredPersonCase />} />} />} />
          <Route path={RoutesType.TasksList} element={<ProtectedRoute key={location.pathname} component={<Tasks />} />} />
          <Route path={RoutesType.TaskCase} element={<ProtectedRoute key={location.pathname} component={<ValidatedRoute component={<Task />} />} />} />
          <Route path={RoutesType.EditTask} element={<ProtectedRoute key={location.pathname} component={<ValidatedRoute component={<EditTask />} />} />} />
          <Route path={RoutesType.CreateTask} element={<ProtectedRoute key={location.pathname} component={<CreateTask />} />} />
          <Route path={RoutesType.Contacts} element={<ProtectedRoute key={location.pathname} component={<Contacts />} />} />
          <Route path={RoutesType.Statistics} element={<ProtectedRoute key={location.pathname} component={<Statistics />} />} />
          <Route path={RoutesType.Projects} element={<ProtectedRoute key={location.pathname} component={<Projects />} />} />
          <Route path={RoutesType.BonusProgram} element={<ProtectedRoute key={location.pathname} component={<BonusProgram />} />} />
          <Route path={RoutesType.Feedback} element={<ProtectedRoute key={location.pathname} component={<Feedback />} />} />
          <Route path={RoutesType.Fallback} element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>

  );
};

export default AppRouter;


